module.exports = __webpack_public_path__ + "static/media/line-half.c80ac400.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/line-half.svg
// module id = 806
// module chunks = 0